export const PROMOTION_ROUTER_ROOT = '/promotion';
export const PROMOTION_ROUTER_NEW = PROMOTION_ROUTER_ROOT + '/new';
export const PROMOTION_ROUTER_EDIT = PROMOTION_ROUTER_ROOT + '/edit/:id';



// WEBPACK FOOTER //
// ./src/components/Promotions/constants.ts